import { observer } from 'mobx-react-lite';

import DevPanel from 'devtools/DevPanel';
import { crewTimelineStore } from 'pages/CrewTimeline/CrewTimelineStore';

import styles from './styles.module.css';

const MockDataToggle = observer(() => {
	const { useMockData, setUseMockData } = crewTimelineStore;

	return (
		<DevPanel title="Test data">
			<label className={styles.label}>
				<input
					type="checkbox"
					checked={useMockData}
					onChange={(e) => setUseMockData(e.target.checked)}
				/>
				Use mock data
			</label>
		</DevPanel>
	);
});

export default MockDataToggle;
